module.exports = __webpack_public_path__ + "img/table2.8c1fead7.png";